import { render } from "./ObjectLens.vue?vue&type=template&id=28768f33&scoped=true"
import script from "./ObjectLens.vue?vue&type=script&lang=js"
export * from "./ObjectLens.vue?vue&type=script&lang=js"

import "./ObjectLens.vue?vue&type=style&index=0&id=28768f33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28768f33"]])

export default __exports__